import React, { useContext } from "react";
import Ctx from "../../contexts/AppContext";
import Ic from "../common/Ic";
import { navTabs, navTabMap, TAB_FEATURE } from "../../constants/navConfig";

// Desktop-only left navigation rail. Renders the SAME tabs as the mobile
// BottomBar (via the shared navConfig) plus Settings/Logout, vertically.
// Only mounted by App.js's desktop chrome (IS_DESKTOP); the mobile build
// never imports it.
export const SIDEBAR_W = 248;

export default function DesktopSidebar() {
  const { t, h, page, go, role, plan, setShareModalOpen, doLogout, orgName, userName } = useContext(Ctx);

  const planFeatures = (role === "landlord" && plan?.features) ? plan.features : null;
  const tabs = navTabs(role, t);
  const tabMap = navTabMap(role);
  const activeTab = tabMap[page] || page;

  const item = (id, ic, label, opts = {}) => {
    const active = !opts.plain && activeTab === id;
    const locked = planFeatures && TAB_FEATURE[id] && !planFeatures.includes(TAB_FEATURE[id]);
    return (
      <button key={id} onClick={opts.onClick || (() => go(id))}
        onMouseEnter={(e) => { if (!active) e.currentTarget.style.background = h.ib || `${h.ac}08`; }}
        onMouseLeave={(e) => { if (!active) e.currentTarget.style.background = "transparent"; }}
        style={{
          display: "flex", alignItems: "center", gap: 12, width: "100%",
          padding: "11px 13px", borderRadius: 12, border: "none", cursor: "pointer",
          background: active ? `${h.ac}12` : "transparent",
          color: opts.danger ? h.rd : (active ? h.ac : (h.tx)),
          fontSize: 14, fontWeight: active ? 700 : 600, fontFamily: "inherit",
          textAlign: "left", transition: "background 0.15s", opacity: locked ? 0.55 : 1,
        }}>
        <Ic n={ic} s={19} c={opts.danger ? h.rd : (active ? h.ac : (h.tt || h.sc))} />
        <span style={{ flex: 1 }}>{label}</span>
        {locked && <span style={{ fontSize: 11 }}>🔒</span>}
      </button>
    );
  };

  return (
    <aside style={{
      width: SIDEBAR_W, flexShrink: 0, position: "sticky", top: 0, alignSelf: "flex-start",
      height: "100vh", boxSizing: "border-box",
      borderRight: `1px solid ${h.bd}`, background: h.cd || h.bg,
      display: "flex", flexDirection: "column", padding: "18px 14px",
    }}>
      {/* Brand */}
      <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "4px 8px 16px" }}>
        <div style={{ width: 38, height: 38, borderRadius: 12, background: `linear-gradient(135deg, ${h.ac}, ${h.ac}cc)`, display: "flex", alignItems: "center", justifyContent: "center", boxShadow: `0 6px 16px ${h.ac}40` }}>
          <Ic n="bldg" s={19} c="#fff" />
        </div>
        <div style={{ minWidth: 0 }}>
          <div style={{ fontSize: 15, fontWeight: 800, color: h.tx, letterSpacing: "-0.3px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{orgName || "ProRentz"}</div>
          <div style={{ fontSize: 11, fontWeight: 600, color: h.ts || h.sc }}>{role === "landlord" ? t.landlord : role === "service" ? (t.servicePerson || "Service") : t.tenant}</div>
        </div>
      </div>

      {/* Primary nav */}
      <nav style={{ display: "flex", flexDirection: "column", gap: 4, flex: 1, overflowY: "auto" }}>
        {tabs.map(([id, ic, label]) => item(id, ic, label))}
        {role === "landlord" && item("share", "send", t.share || "Share", { plain: true, onClick: () => setShareModalOpen && setShareModalOpen(true) })}
      </nav>

      {/* Footer: settings + logout */}
      <div style={{ display: "flex", flexDirection: "column", gap: 4, borderTop: `1px solid ${h.bd}`, paddingTop: 8, marginTop: 8 }}>
        {item("settings", "gear", t.settings || "Settings", { plain: true, onClick: () => go("settings") })}
        {item("logout", "out", t.logout || "Log out", { plain: true, danger: true, onClick: doLogout })}
      </div>
    </aside>
  );
}
